const state = {
  loginStatus: false,
  loginType: '',
  managerRouter: [],
  companyName: '',
  companyList: [],
}

export default state
